import React from "react";
import AdminSectionShell from "../components/AdminSectionShell";
import { usePermissao } from "../uteis/permissaoAdm/usePermissao";
import ViewWhatsappProviderHealth from "../views/ViewWhatsappProviderHealth";

const WhatsappProviderHealth: React.FC = () => {
  const { isLoading, isValid } = usePermissao("OPE");

  if (isLoading) {
    return <p>Verificando permissão...</p>;
  }

  if (!isValid) {
    return null;
  }

  return (
    <AdminSectionShell backTo="/marketing">
      <ViewWhatsappProviderHealth />
    </AdminSectionShell>
  );
};

export default WhatsappProviderHealth;
